import * as React from 'react';
import { v4 as uuidv4 } from "uuid";

interface FilterItem {
    filterKey: string;
    filterName: string;
    filterId: string;
    parentId?: string;
    count?: number;
}

interface FilterModel {
    onToggle: (filterKey: string, filterId: number) => void;
    selectedFilterCategory: Record<string, number[]>;
    searchFasets: FilterItem[][];
    resetFilter: () => void;
}

const FilterPills: React.FC<FilterModel> = (props) => {

    const [visible, setVisible] = React.useState(false);
    
    const handleReset = () => {
        setVisible(false);
        props.resetFilter();
    }
    
    const checked = (id: number) => {
        for (const key in props.selectedFilterCategory) {
            const arr = props.selectedFilterCategory[key];
            if (Array.isArray(arr) && arr.includes(id)) {
                return true;
            }
        }
        return false;
    };

    return (
        <>
            <ul className={`${visible ? 'flex flex-wrap gap-3 my-3' : 'hidden'}`}>
                {props.searchFasets !== undefined && (
                    <>
                        {props.searchFasets.map((filters: FilterItem[]) => {
                            return (
                                <>
                                    {filters.map( (filt: FilterItem) => {
                                        if (checked(Number(filt.filterId))) {
                                            if (!visible) {
                                                setVisible(true);                                                
                                            }

                                            return (
                                                <li key={uuidv4()}>
                                                    <button onClick={() => props.onToggle(filt.filterKey, Number(filt.filterId))} type="button" className='btn-pill flex items-center justify-between gap-2 capitalize'>
                                                        <span>{filt.filterName}</span>
                                                        <span className="icon-x" aria-hidden="true"></span>
                                                    </button>
                                                </li>
                                            )
                                        }
                                    })}
                                </>
                            )
                        })}
                    </>
                )}
                <li>
                    <button onClick={handleReset} type="button" className='btn-ghost'>
                        Fjern alle filtre
                    </button>
                </li>
            </ul>                
        </>
    );
};

export default FilterPills;

